import React, { useEffect, useState } from "react";
import {
  FaFileAlt,
  FaCode,
  FaCheckSquare,
  FaWrench,
  FaRocket,
  FaStar,
} from "react-icons/fa";
import i18n from "../i18n";

const DevOpsProcess = () => {
  const [langTick, setLangTick] = useState(0);

  useEffect(() => {
    const onLang = () => setLangTick((x) => x + 1);
    i18n.on("languageChanged", onLang);
    return () => i18n.off("languageChanged", onLang);
  }, []);

  // langTick нужен, чтобы компонент точно перерендерился
  // eslint-disable-next-line no-unused-vars
  const _ = langTick;

  const steps = [
    {
      icon: <FaFileAlt className="text-indigo-500 text-2xl" />,
      title: i18n.t("devops.plan.title"),
      description: i18n.t("devops.plan.description"),
    },
    {
      icon: <FaCode className="text-indigo-500 text-2xl" />,
      title: i18n.t("devops.develop.title"),
      description: i18n.t("devops.develop.description"),
    },
    {
      icon: <FaCheckSquare className="text-indigo-500 text-2xl" />,
      title: i18n.t("devops.test.title"),
      description: i18n.t("devops.test.description"),
    },
    {
      icon: <FaWrench className="text-indigo-500 text-2xl" />,
      title: i18n.t("devops.build.title"),
      description: i18n.t("devops.build.description"),
    },
    {
      icon: <FaRocket className="text-indigo-500 text-2xl" />,
      title: i18n.t("devops.deploy.title"),
      description: i18n.t("devops.deploy.description"),
    },
    {
      icon: <FaStar className="text-indigo-500 text-2xl" />,
      title: i18n.t("devops.monitor.title"),
      description: i18n.t("devops.monitor.description"),
    },
  ];

  return (
    <section className="bg-white py-28 md:py-36 px-6 sm:px-10 lg:px-20">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-start justify-between gap-10 lg:gap-24">
        <div className="w-full max-w-md">
          <img
            src={`${process.env.PUBLIC_URL}/images/devops.png`}
            alt="DevOps Infinity Loop"
            className="w-full h-auto"
          />
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-8 w-full max-w-3xl">
          {steps.map((step, index) => (
            <div
              key={index}
              className="flex flex-col items-start text-left transform transition-transform duration-300 hover:scale-105"
            >
              <div className="bg-indigo-100 p-4 rounded-full mb-4">
                {step.icon}
              </div>
              <h4 className="font-semibold text-lg mb-2">{step.title}</h4>
              <p className="text-sm text-gray-600">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DevOpsProcess;








